import Style from "./NotFound.module.css";
function NotFound() {
  return (
    <>
      <h1>NotFound</h1>
    </>
  );
}

export default NotFound;
